import { Fragment } from 'react'
import { Text } from '@chakra-ui/react'
import { NextSeo } from 'next-seo'

import TermAndPrivacyLayout from '@/features/TermsAndPrivacy/components/TermAndPrivacyLayout'
import { renderTemplate } from '@/features/TermsAndPrivacy/helpers'

import NavigationBar from '@/components/organisms/NavigationBar'
import { Footer } from '@/components/organisms/Footer'

function TermsOfUse(): React.ReactElement {
  const type = 'terms'

  return (
    <Fragment>
      <NextSeo title="Terms of Use" />
      <NavigationBar />
      <TermAndPrivacyLayout>
        <Text as="h1">ข้อกำหนดและเงื่อนไขในการใช้งาน</Text>
        <Text>
          ข้อกำหนดและเงื่อนไขในการใช้งาน LearnPDPA ฉบับนี้
          (&quot;ข้อกำหนดและเงื่อนไขฯ&quot;)
          ได้ระบุถึงข้อกำหนดและเงื่อนไขในการใช้งานผลิตภัณฑ์และบริการใด ๆ
          (เรียกรวมกันว่า “บริการ”) ของ บริษัท เดต้า ว้าว จำกัด
          (&quot;บริษัท&quot; หรือ “เรา”) แก่ผู้ใช้บริการ (โดยแต่ละรายจะเรียกว่า
          &quot;ผู้ใช้&quot; หรือ “คุณ” ขึ้นอยู่กับเนื้อหา) ในฐานะผู้ใช้บริการ
          โปรดอ่านข้อตกลงนี้อย่างละเอียดและครบถ้วน
        </Text>
        <Text>
          อย่างไรก็ดี โปรดรับทราบว่าการเข้าใช้เว็บไซต์หรือบริการของเรา
          เราจะถือว่าคุณได้อ่านข้อตกลงนี้และยอมรับข้อกำหนดและเงื่อนไขทั้งหมด
          ตกลงที่จะผูกพันตามข้อตกลงนี้
          หากคุณไม่ยินยอมที่จะปฏิบัติตามเงื่อนไขของข้อตกลงนี้จะส่งผลให้คุณไม่ได้รับอนุญาตในการเข้าใช้หรือเข้าถึงเว็บไซต์และบริการของเว็บไซต์
        </Text>

        {renderTemplate(type)}
        <br />
        <hr />
        <br />
        <Text id="end-content" sx={{ fontWeight: 'medium' }}>
          ข้อกำหนดและเงื่อนไขในการใช้งานนี้แก้ไขล่าสุดและมีผลใช้บังคับตั้งแต่วันที่
          23 เมษายน 2564
        </Text>
      </TermAndPrivacyLayout>
      <Footer />
    </Fragment>
  )
}

export default TermsOfUse
